import React from "react";
import styled from "styled-components";

export type SearchMode = "fuzzy" | "exact";

type ModeSwitchProps = {
  mode: SearchMode;
  setMode: (mode: SearchMode) => void;
  light?: boolean;
  className?: string;
};

const OPTIONS: { value: SearchMode; label: string; title: string }[] = [
  {
    value: "fuzzy",
    label: "Fuzzy",
    title: "Fuzzy: close matches and typos too",
  },
  {
    value: "exact",
    label: "Exact",
    title: "Exact: only results that match exactly",
  },
];

// The Fuzzy/Exact switch: dark inside the search field, light in the dropdown
const ModeSwitch: React.FC<ModeSwitchProps> = ({
  mode,
  setMode,
  light = false,
  className,
}) => (
  <Track
    role="radiogroup"
    aria-label="Match type"
    $light={light}
    className={className}
  >
    {OPTIONS.map((option) => (
      <Option
        key={option.value}
        type="button"
        role="radio"
        aria-checked={mode === option.value}
        $selected={mode === option.value}
        $light={light}
        title={option.title}
        onClick={() => setMode(option.value)}
      >
        {option.label}
      </Option>
    ))}
  </Track>
);

const Track = styled.div<{ $light: boolean }>`
  display: flex;
  gap: 2px;
  padding: 2px;
  background-color: ${(props) =>
    props.$light ? "#eef1f4" : "rgba(0, 0, 0, 0.18)"};
  border-radius: 999px;
`;

const Option = styled.button<{ $selected: boolean; $light: boolean }>`
  height: ${(props) => (props.$light ? "24px" : "26px")};
  padding: 0 12px;
  background-color: ${(props) => (props.$selected ? "#fff" : "transparent")};
  border: none;
  border-radius: 999px;
  box-shadow: ${(props) =>
    props.$selected && props.$light ? "0 1px 2px rgba(0, 0, 0, 0.16)" : "none"};
  color: ${(props) =>
    props.$selected
      ? props.theme.colors.idataDarkBlue
      : props.$light
      ? props.theme.colors.idataDarkGrey
      : "#fff"};
  font-family: inherit;
  font-size: 13.44px;
  font-weight: 600;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export default ModeSwitch;
